<template>
  <span v-if="onlyDot" v-b-tooltip.hover :title="text" class="dot ml-2" :style="{ backgroundColor: dotColor }"></span>
  <span v-else class="status">
    <span class="dot" :style="{ backgroundColor: dotColor }"></span>
    <span>{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: ["status", "onlyDot"],
  computed: {
    dotColor() {
      let bgClass = "#FF7C48";
      if (this.status == "IN_PROGRESS") {
        bgClass = "#2998FF";
      } else if (this.status == "DONE") {
        bgClass = "#2ECD06";
      } else if (this.status == "UNWORKED") {
        bgClass = "gray";
      } else if (this.status == "NOT_FIT") {
        bgClass = "red";
      } else if (this.status == "APPROVAL") {
        bgClass = "#9440FF";
      }
      return bgClass;
    },
    text() {
      if (this.status == "IN_PROGRESS") {
        return this.$t("task.status.in-progress");
      } else if (this.status == "DONE") {
        return this.$t("task.status.done");
      } else if (this.status == "UNWORKED") {
        return this.$t("task.status.unworked");
      } else if (this.status == "NOT_FIT") {
        return this.$t("task.status.not-fit");
      } else if (this.status == "APPROVAL") {
        return this.$t("task.status.approval");
      }
      return this.$t("task.status.todo");
    },
  },
};
</script>
<style scoped>
.status {
  font-weight: bold;
  padding: 5px 10px;
  background-color: rgb(233 233 233);
  border-radius: 7px;
  min-width: 100px;
}
</style>
